function normalize() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return args.reduce((result, arg) => {
    if (typeof arg === 'string') {
      result[arg] = true;
      return result;
    }
    for (let token of Object.keys(arg)) {
      result[token] = arg[token];
    }
    return result;
  }, {});
}
export function classNames() {
  let mapping = normalize(...arguments);
  return Object.keys(mapping).reduce((result, token) => {
    if (mapping[token]) {
      result.push(token);
    }
    return result;
  }, []).join(' ');
}
export function applyClassNames(element) {
  for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }
  let mapping = normalize(...args);
  for (let token of Object.keys(mapping)) {
    element.classList.toggle(token, mapping[token]);
  }
}